import { Button } from '@material-ui/core';

import { TransitionScreen } from '../TransitionScreen';

export const InviteRequiredPage = () => {
  return (
    <TransitionScreen
      title="Confidence is invite-only"
      description={
        <span>
          Confidence is currently available by invitation only. Contact us to
          learn more about how Confidence can help you experiment like Spotify.
        </span>
      }
      actions={
        <Button
          variant="contained"
          color="primary"
          size="large"
          href="mailto:confidence@spotify.com"
        >
          Contact us
        </Button>
      }
    />
  );
};
